module.exports = __webpack_public_path__ + "static/7-2@3x-aaa40467e8bbbcb1a35f009086447767.png";